<template>
  <div>
    <div v-if="!questionAnswered" class="px-8">
      <div class="mt-12 py-5 text-left">
        <session-logo :session="session"></session-logo>

        <!-- <p class="text-sm mb-2">Frage {{ question.prio }} von 6</p> -->
        <h1 class="text-lg font-extralight">
          {{ generatedQuestion }}
        </h1>
        <p v-if="question.sub_question" class="mt-3 text-sm  font-extralight">
          {{ question.sub_question }}
        </p>

        <div class="border-t border-gray-400 mt-4"></div>
      </div>

      <form @submit.prevent="submit" novalidate class="mt-1 text-center">
        <div v-for="(keyword, idx) in form.keywords" :key="idx" class="mb-2">
          <div class="ml-auto mr-auto max-w-4xl rounded-md shadow-sm">
            <textarea v-model="keyword.text" :disabled="sending" rows="1" class="
                shadow-sm
                focus:ring-markencode-blue focus:border-markencode-blue
                mt-1
                block
                w-full
                border border-gray-300
                rounded-md
                
                placeholder:text-gray-400
              " :placeholder="placeholder(idx)"></textarea>
          </div>


        </div>

        <submit-button :sending="sending" :validated="validated" class="max-w-4xl ml-auto mr-auto mt-6">{{
          translations.save }}</submit-button>
      </form>
    </div>



    <div v-if="questionAnswered" class="mt-6 px-8 py-5 text-center mx-auto">
      <h1 class="text-3xl font-extralight mb-13">
        {{ translations.thank_you }}
      </h1>

      <!-- <div class="border-t border-gray-400 mt-8 mb-8"></div> -->

      <a :href="route('diy-workshops.phase', {
        uuid: participant.uuid,
      })
        "
        class="block mx-auto mt-12 w-min rounded-md border border-transparent px-2 py-3 bg-brandpreneurship-dark-gray  font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:border-black focus:shadow-outline-red transition ease-in-out duration-150 text-sm leading-5 z-50">WEITER</a>
    </div>



  </div>
</template>

<script>
import SubmitButton from '@/Shared/SubmitButton';
import HorizontalDivider from '@/Shared/HorizontalDivider';
import { throttle } from 'lodash';
import SessionLogo from '@/Pages/DiyWorkshop/Shared/SessionLogo';

export default {
  components: {
    SubmitButton,
    HorizontalDivider,
    SessionLogo,
  },

  props: {
    translations: {},
    participant: {
      required: true,
    },
    question: {
      required: true,
    },
    session: {
      required: true,
      type: Object,
    },
    answerParameters: {},
  },

  data() {
    return {
      sending: false,
      answered: false,
      form: {
        keywords: [],
      },
    };
  },

  methods: {
    placeholder(idx) {
      if (this.question.parameters.options.placeholder) {
        return this.question.parameters.options.placeholder;
      }

      return `${idx + 1}. Eigenschaft`;
    },

    submit() {
      this.sending = true;

      window.axios
        .post(
          this.route('diy-workshops.questions.store', {
            uuid: this.participant.uuid,
            questionId: this.question.id,
          }),
          this.form
        )
        .then(() => {
          this.sending = false;
          // this is an easy way to change the workflow:
          // now after clicking on "save" the user autimatically 
          // lands on the next question
          window.location.reload();
          // this.answered = true;
        })
        .catch((error) => {
          this.sending = false;
        });
    },
  },

  computed: {
    generatedQuestion() {

      if (!this.question?.brandname && !this.session.brandname && this.question?.question_default) {
        return this.question?.question_default;
      }

      if (this.question?.is_placeholder_question && (this.question?.brandname || this.session.brandname)) {
        return this.question.question.replace('%BRANDNAME', this.question?.brandname || this.session.brandname);
      }

      return this.question.question;
    },
    
    // generatedQuestion() {

    //   if (this.question?.is_placeholder_question) {
    //     return this.question.question.replace('%BRANDNAME', this.question?.brandname || this.session.brandname);
    //   }

    //   return this.question.question;
    // },

    validated() {
      return !this.form.keywords.filter((keyword) => !keyword.text).length;
    },
    questionAnswered() {
      return this.answerParameters || this.answered;
    },


    // channel() {
    //   return Echo.channel(
    //     'markencode-app.session.' + this.participant.markencode_session.id
    //   );
    // },
  },

  created() {
    for (let i = 0; i < this.question.parameters.options.keywords; i++) {
      this.form.keywords.push({ text: '' });
    }
  },

};
</script>